import gsap from 'gsap';

export default class TypingAnimation {
  constructor(element) {
    this.element = element;
    this.originalHTML = this.element.innerHTML;
    const height = this.element.offsetHeight;
    this.element.style.minHeight = `${height}px`;
    this.element.innerHTML = '';
    this.element.style.visibility = 'hidden';
  }

  init() {
    // GSAPのScrollTriggerを使って、要素が表示されたらアニメーションを開始
    gsap.to(this.element, {
      scrollTrigger: {
        trigger: this.element,
        start: 'top 80%', // 要素の上端がビューポートの80%の位置に来たら
        once: true, // 1度だけ実行
        onEnter: () => this.startAnimation(),
      },
    });
  }

  startAnimation() {
    if (this.element) {
      this.element.style.visibility = 'visible';
      const tokens = this.originalHTML.match(/<[^>]+>|[\s\S]/g) || [];
      const counter = { value: 0 };
      gsap.to(counter, {
        value: tokens.length,
        duration: tokens.length * 0.015, // 文字数に応じた時間
        ease: 'none',
        onUpdate: () => {
          this.element.innerHTML = tokens.slice(0, Math.round(counter.value)).join('');
        },
      });
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const typingElements = document.querySelectorAll('.u-animation-typing');
  typingElements.forEach(element => {
    new TypingAnimation(element).init();
  });
});
